import { connectionStore, connectionCloseHandler, connectWithSubscriptions, getSubscribersForQueryId } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
function message(x) {
    return getSubscribersForQueryId(SDQuerySubscribersStore, x.id).map(y => {
        if (typeof x.error !== "undefined" && typeof y.onError === "function") {
            y.onError(x.error.data);
        }
        else if (typeof x.result !== "undefined") {
            y.onData(x.result);
        }
        return y;
    });
}
function open(x) {
    // code available only in debug builds is excluded from coverage
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development") {
        console.warn("Opened socket:", x);
    }
}
function close(x) {
    let res = [false, -1];
    // code available only in debug builds is excluded from coverage
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development") {
        console.warn("Closed socket:", x);
    }
    const conn = connectionStore.get(ConnectionNames.sports);
    if (conn) {
        res = connectionCloseHandler(1000, connectWithSubscriptions.bind(undefined, conn, SDQuerySubscribersStore), x);
    }
    return res;
}
export function sportsSocketConnectionHandlers(rqFormatter, rsFormatter) {
    return {
        open, close, message,
        requestFormatter: rqFormatter,
        responseFormatter: rsFormatter,
    };
}
//# sourceMappingURL=sportsSocketConnectionHandlers.js.map